import React from 'react'

import styled from 'styled-components'

const StyledContentBlockWrapper = styled.div`
  width: 100%;
  background-color: ${props => props.backgroundColor};
`
const StyledContentBlock = styled.div`
  margin: auto;
  padding: 100px 20px;
  max-width: 1160px;
  @media (max-width: 700px) {
    padding: 40px 20px;
  }
  display: flex;
  flex-direction: column;
`

const ContentBlock = ({ backgroundColor = 'white', children }) => {
  return (
    <StyledContentBlockWrapper backgroundColor={backgroundColor}>
      <StyledContentBlock>
        {children}
      </StyledContentBlock>
    </StyledContentBlockWrapper>
  )
}

export default ContentBlock
